__turbopack_context__.v({
  "body_rich_text": "ExpansionPanel-module-scss-module__54gHPa__body_rich_text",
  "direction__column": "ExpansionPanel-module-scss-module__54gHPa__direction__column",
  "direction__row": "ExpansionPanel-module-scss-module__54gHPa__direction__row",
  "expansion-item-list": "ExpansionPanel-module-scss-module__54gHPa__expansion-item-list",
  "gradient-glow-blue": "ExpansionPanel-module-scss-module__54gHPa__gradient-glow-blue",
  "gradient-glow-neon": "ExpansionPanel-module-scss-module__54gHPa__gradient-glow-neon",
  "gradient-glow-orange": "ExpansionPanel-module-scss-module__54gHPa__gradient-glow-orange",
  "gradient-glow-pink": "ExpansionPanel-module-scss-module__54gHPa__gradient-glow-pink",
  "gradient-glow-snap-pea": "ExpansionPanel-module-scss-module__54gHPa__gradient-glow-snap-pea",
  "gradient-neon-pink": "ExpansionPanel-module-scss-module__54gHPa__gradient-neon-pink",
  "gradient-pink-blue": "ExpansionPanel-module-scss-module__54gHPa__gradient-pink-blue",
  "gradient-pink-orange": "ExpansionPanel-module-scss-module__54gHPa__gradient-pink-orange",
  "layout__content-leading": "ExpansionPanel-module-scss-module__54gHPa__layout__content-leading",
  "layout__content-trailing": "ExpansionPanel-module-scss-module__54gHPa__layout__content-trailing",
  "module-base": "ExpansionPanel-module-scss-module__54gHPa__module-base",
  "module-content-swap": "ExpansionPanel-module-scss-module__54gHPa__module-content-swap",
  "module_block__contained": "ExpansionPanel-module-scss-module__54gHPa__module_block__contained",
  "module_block__uncontained": "ExpansionPanel-module-scss-module__54gHPa__module_block__uncontained",
  "module_breadcrumbs": "ExpansionPanel-module-scss-module__54gHPa__module_breadcrumbs",
  "section_bg_fill__base": "ExpansionPanel-module-scss-module__54gHPa__section_bg_fill__base",
  "section_bg_fill__gradient": "ExpansionPanel-module-scss-module__54gHPa__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "ExpansionPanel-module-scss-module__54gHPa__section_bg_fill__no-fill",
  "section_bg_fill__raised": "ExpansionPanel-module-scss-module__54gHPa__section_bg_fill__raised",
  "section_container": "ExpansionPanel-module-scss-module__54gHPa__section_container",
  "with_breadcrumb": "ExpansionPanel-module-scss-module__54gHPa__with_breadcrumb",
  "with_navbar": "ExpansionPanel-module-scss-module__54gHPa__with_navbar",
});
